<template>
    <div class="app-container">
        <el-form inline>
            <el-form-item>
                <el-input v-model="queryParams.searchKey" size="small" placeholder="关键字" style="width: 150px;" class="filter-item margin-right-10" @keyup.enter.native="handleFilter" />
                <el-button class="el-icon-search" type="success" size="small" @click="handleFilter">搜索</el-button>
                <el-button class="el-icon-plus" type="warning" size="small" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="accountList" border size="mini">
            <el-table-column label="id" prop="id" align="center" width="100" />
            <el-table-column label="餐厅名称" prop="name" align="center" width="200" />
            <el-table-column label="省" prop="name" align="center" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.provinceId">{{ scope.row.provinceName[0].name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="类型" prop="sightsType" align="center" min-width="200" />
            <el-table-column label="创建时间" prop="gmtCreate" align="center" width="150" />
            <el-table-column label="更新时间" prop="gmtUpdate" align="center" width="150" />
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" plain @click="handleUpdate(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <base-pagination v-show="total>0" :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.size" @pagination="initData" />

        <el-dialog :title="editConfig.title" :visible.sync="editConfig.show" :close-on-click-modal="false" width="1000px">
            <el-form label-width="120px" style="padding-right:40px;">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="省">
                            <el-select v-model="editForm.provinceId" filterable remote :remote-method="getCityList" placeholder="餐厅所在省">
                                <el-option v-for="item in cityList" :key="item.id" :value="item.id" :label="`${item.name}(${item.pathName})`" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                         <el-form-item label="餐厅名称">
                            <el-input v-model="editForm.name" placeholder="餐厅名称" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="餐厅类型">
                    <el-checkbox-group v-model="editForm.sightsType">
                        <el-checkbox v-for="item in sightsTypeList" :key="item" :label="item" />
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="餐厅介绍">
                    <Tinymce ref="introduce" v-model="editForm.introduce" width="800px" :height="200" :page-id.sync="editForm.id" />
                </el-form-item>
                <el-form-item label="餐厅图片">
                    <upload-multipleimage :file-list.sync="editForm.image" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="editConfig.show=false">关闭</el-button>
                <el-button type="primary" @click="handleConfirm">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { restaurantPage, restaurantSave, restaurantUpdate } from '@/api/itinerary.js'
import { cityList } from '@/api/hotel.js'
import UploadMultipleimage from '@/components/UploadMultipleimage'
import Tinymce from '@/components/Tinymce'
const editFormDefault = {
    id: '',
    provinceId: '',
    name: '',
    image: [],
    introduce: '',
    sightsType: []
}
export default {
    name: 'ItineraryRestaurant',
    components: { UploadMultipleimage, Tinymce },
    data() {
        return {
            accountList: [],
            queryParams: {
                page: 1,
                size: 20,
                searchKey: ''
            },
            total: 0,
            loading: false,
            editForm: Object.assign({}, editFormDefault),
            editConfig: {
                show: false,
                type: 'add',
                title: '添加餐厅'
            },
            cityList: [],
            sightsTypeList: ['米其林星级', '黑珍珠等级', '世界50佳', '洲际50佳']
        }
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            this.loading = true
            restaurantPage(this.queryParams).then(res => {
                this.loading = false
                if (Number(res.status) === 2000) {
                    this.accountList = res.data.records
                    this.total = Number(res.data.total)
                }
            })
        },
        handleFilter() {
            this.queryParams.page = 1
            this.initData()
        },
        getCityList (searchKey) {
            cityList({ level: 3, page: 1, size: 100, searchKey: searchKey }).then(res => {
                if (Number(res.status) === 2000) {
                    this.cityList = res.data.records
                }
            })
        },
        handleAdd() {
            this.editConfig.show = true
            this.editConfig.title = '添加餐厅'
            this.editConfig.type = 'add'
            this.editForm = Object.assign({}, editFormDefault)
        },
        handleUpdate(row) {
            this.editConfig.show = true
            this.editConfig.title = '编辑餐厅'
            this.editConfig.type = 'edit'
            this.editForm = { ...row }
            this.editForm.provinceId = Number(this.editForm.provinceId)
            this.editForm.sightsType = this.editForm.sightsType ? this.editForm.sightsType.split(',') : []
            this.editForm.image = this.editForm.image ? this.editForm.image.split(',') : []
            this.cityList = row.provinceName
        },
        handleConfirm() {
            const params = { ...this.editForm }
            params.image = params.image ? params.image.join(',') : ''
            params.sightsType = params.sightsType ? params.sightsType.join(',') : ''
            if (this.editConfig.type === 'add') {
                restaurantSave(params).then(res => {
                    if (Number(res.status) === 2000) {
                        this.initData()
                        this.$message({
                            type: 'success',
                            message: '新增餐厅成功'
                        })
                        this.editConfig.show = false
                    }
                })
            } else if (this.editConfig.type === 'edit') {
                restaurantUpdate(params).then(res => {
                    if (Number(res.status) === 2000) {
                        this.initData()
                        this.$message({
                            type: 'success',
                            message: '修改餐厅成功'
                        })
                        this.editConfig.show = false
                    }
                })
            }
        }
    }
}
</script>
